import { render, staticRenderFns } from "./DefaultContent-RecentlyViewed.vue?vue&type=template&id=92911bc6&"
import script from "./DefaultContent-RecentlyViewed.vue?vue&type=script&lang=js&"
export * from "./DefaultContent-RecentlyViewed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports